import React, {useState} from "react";
import { Button, Col, FormGroup, Modal, Row, Container, Tab ,Tabs ,Card} from "react-bootstrap";
import { Form, Input} from 'antd';
import { ImageElement,Breadcrumb, LoginHeader} from "../../components";
import { Link } from "react-router-dom";
    function MyBooking() {
         const breadcrumb = [
         {
         path: '/dashboard',
         name: 'Home',
         },
         {
         path: '#',
         name: 'My Bookings',
         }
      ];
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { TextArea } = Input;
return(
<>
<LoginHeader/>
<div className="main-content myBookingsPage">
   {/* page content */}
   <div className="pageContent">
      <Container className="container-lg">
         <Breadcrumb title="My Bookings" breadcrumb={breadcrumb}/>
         <div className="myBookingsPage_inner cardHeight bg-white br-10">
            <div className="commonTabs">
               <Tabs
                  defaultActiveKey="On Going Services"
                  transition={false}
                  id="noanim-tab-example"
                  className="mb-3"
                  >
                  <Tab eventKey="On Going Services" title="On Going Services">
                        {/* EMPTY SCREEN_______ */}
                        {/* <Col className="col-12">
                            <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                <div className="noList_inner">
                                <ImageElement source="no-booking.svg" className="img-fluid"/>
                              <div className="noList_cnt">
                                <h5>No Ongoing Booking</h5>
                                <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              </div>
                                </div>
                           
                            </div>
                        </Col> */}
                     <Row className="g-3">
                        <Col xl={4} md={6}>
                            <div className="bookingBox">
                            <Card>
                                <Card.Header>
                                    <ul className="list-unstyled mb-0 d-flex">
                                        <li>
                                        Booking ID: <span>1458265</span>
                                        </li>
                                        <li>
                                        Status: <span className="text-500">Accepted</span>
                                        </li>
                                    </ul>
                                </Card.Header>
                                <Card.Body>
                                    <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                       <div className="bookingBox_img flex-shrink-0">
                                          <ImageElement source="user-1.png" className="img-fluid"/>
                                       </div>
                                       <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                          <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                          <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                       </div>
                                    </div>
                                    <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                                </Card.Body>
                            </Card>
                            </div>
                        </Col>
                        {/* <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                 <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                  <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                  <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                  <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                  <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                  <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                  <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_serviceAdderss text-break flex-grow-1">
                                       <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                       <p className="bookingBox_adderss mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                    </div>
                                 </div>
                                  <Link to="/service-track" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col> */}
                     </Row>
                  </Tab>
                  <Tab eventKey="upcoming" title="Upcoming">
                     {/* EMPTY SCREEN_______ */}
                     {/* <Col className="col-12">
                            <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                <div className="noList_inner">
                                <ImageElement source="no-booking.svg" className="img-fluid"/>
                              <div className="noList_cnt">
                                <h5>No Upcoming Booking</h5>
                                <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              </div>
                                </div>
                           
                            </div>
                        </Col> */}
                     <Row className="g-3">
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Cancelled</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 {/* <Button variant="outline-primary" className="w-100" onClick={handleShow}>Cancel Booking</Button> */}
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <Button variant="outline-primary" className="w-100" onClick={handleShow}>Cancel Booking</Button>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <Button variant="outline-primary" className="w-100" onClick={handleShow}>Cancel Booking</Button>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <Button variant="outline-primary" className="w-100" onClick={handleShow}>Cancel Booking</Button>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <Button variant="outline-primary" className="w-100" onClick={handleShow}>Cancel Booking</Button>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Accepted</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <Button variant="outline-primary" className="w-100" onClick={handleShow}>Cancel Booking</Button>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                     </Row>
                  </Tab>
                  <Tab eventKey="past" title="Past" >
                     {/* EMPTY SCREEN_______ */}
                     {/* <Col className="col-12">
                            <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                <div className="noList_inner">
                                <ImageElement source="no-booking.svg" className="img-fluid"/>
                              <div className="noList_cnt">
                                <h5>No Past Booking</h5>
                                <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              </div>
                                </div>
                           
                            </div>
                        </Col> */}
                     <Row className="g-3">
                        
                        <Col xl={4} md={6}>
                        <Link to="/paynow" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500">Pending</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                        <Col xl={4} md={6}>
                        <Link to="/rating" className="bookingBox">
                           <Card>
                              <Card.Header>
                                 <ul className="list-unstyled mb-0 d-flex">
                                    <li>
                                       Booking ID: <span>1458265</span>
                                    </li>
                                    <li>
                                       Qty: <span>1d</span>
                                    </li>
                                    <li>
                                       Status: <span className="text-500">Finished</span>
                                    </li>
                                 </ul>
                              </Card.Header>
                              <Card.Body>
                                 <Card.Title>Schedule A Replacement Quote (Heating and Cooling Equipment)</Card.Title>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <div className="bookingBox_location"><em className="gg-marker me-2"/>Service Address</div>
                                    <p className="bookingBox_adderss">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                 </div>
                                 <div className="bookingBox_dateTime">
                                    <span><em className="gg-payment-status me-2"/>Payment Status : <span className="status text-500"> Complete</span> </span>
                                 </div>
                              </Card.Body>
                           </Card>
                        </Link>
                        </Col>
                     </Row>
                  </Tab>
                  <Tab eventKey="Request" title="Request" >
                     {/* EMPTY SCREEN_______ */}
                     {/* <Col className="col-12">
                            <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                <div className="noList_inner">
                                <ImageElement source="no-booking.svg" className="img-fluid"/>
                              <div className="noList_cnt">
                                <h5>No Requested Booking</h5>
                                <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              </div>
                                </div>
                           
                            </div>
                        </Col> */}
                     <Row className="g-3">
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100000.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-2.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-3.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-2.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-3.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-1.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-2.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                        <Col xl={4} md={6}>
                        <div className="bookingBox">
                           <Card>
                              <Card.Body>
                                 <div className="bookingBox_cnt d-flex align-items-md-center flex-grow-1">
                                    <div className="bookingBox_img flex-shrink-0">
                                       <ImageElement source="user-3.png" className="img-fluid"/>
                                    </div>
                                    <div className="bookingBox_detail flex-grow-1">
                                       <div className="d-md-flex align-items-lg-center">
                                          <div className="flex-grow-1">
                                             <h5>Steven S. Hurd</h5>
                                             <ul className="list-unstyled d-flex starRating mb-0">
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                             </ul>
                                          </div>
                                          <div className="flex-shrink-1">
                                             <p className="mb-0">$100.00</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="bookingBox_dateTime mb-1">
                                    <span><em className="gg-calendar me-2"/>Thu, March 3, 2019 at 8:00 AM– 11:00 AM</span>
                                 </div>
                                 <div className="bookingBox_serviceAdderss text-break">
                                    <p className="bookingBox_adderss"><em className="gg-marker me-2"/>3050 Crestview Terrace Marble Falls, TX 78654</p>
                                 </div>
                                  <Link to="/request-view-details" className="btn btn-outline-primary w-100">View Details</Link>
                              </Card.Body>
                           </Card>
                        </div>
                        </Col>
                     </Row>
                  </Tab>
               </Tabs>
            </div>
         </div>
      </Container>
   </div>
</div>
{/* CANCEL BOOKING */}
<Modal show={show} onHide={handleClose} size="lg" centered id="cancelBooking" className="cancelBooking" backdrop="static">
   <Modal.Header closeButton className="align-items-start">
      <div>
         <Modal.Title className="text-uppercase">Cancel Booking</Modal.Title>
      </div>
   </Modal.Header>
   <Modal.Body>
      <Form>
         <FormGroup className="form-group">
            <label className="ant-label">Reason </label>
            <TextArea size="large" rows={8} placeholder="maxLength is 6" maxLength={8} value="Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Donec Ut Bibendum Elit. Aenean Ultrices Feugiat Orci Sollicitudin Pretium. Morbi Pretium Tristique Sapien, In Elementum Metus Pharetra Et. Sed Nec Orci Sit Amet Ante Venenatis Placerat Elementum Vitae Nibh. Vestibulum Commodo Massa Eu Diam Congue, Eu Finibus Ex Vestibulum. Mauris Dictum Mattis Orci Aliquam Vestibulum. Vivamus Vehicula Nisl Est, In Rhoncus Nunc Cursus At. Ut Vel Metus Velit. Vestibulum Vitae Lectus Id Nibh Pharetra Vehicula Ac Sodales Dolor. Donec Vitae Arcu Lacus."></TextArea>
            
         </FormGroup>
         <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
            <Button variant="light" className="min-200 me-3" onClick={handleClose}>Cancel</Button>
            <Button variant="primary" className="min-200" onClick={handleClose}>Continue</Button>
         </div>
      </Form>
   </Modal.Body>
</Modal>
</>
);
}
export default MyBooking;